import { Box, Flex } from '@mantine/core';

import { T } from '@/theme/assay';

interface MarketingEyebrowProps {
  /** The uppercase mono label. Pass it in sentence case - CSS does the shouting. */
  label: string;
  /** Gates the entrance animation; pass `true` once the section enters the viewport. */
  inView?: boolean;
  /** Seconds to delay the rule draw. The label follows 0.25s later. */
  delay?: number;
}

/**
 * The gold rule + mono label pairing that opens every marketing section.
 * The rule draws left-to-right, then the label rises in behind it.
 */
export function MarketingEyebrow({ label, inView = true, delay = 0.2 }: MarketingEyebrowProps) {
  return (
    <Flex align="center" gap={10}>
      <Box
        style={{
          width: 32,
          height: 1,
          background: T.ore,
          transformOrigin: 'left',
          transform: inView ? undefined : 'scaleX(0)',
          animation: inView
            ? `assay-eyebrow-rule-draw 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${delay}s both`
            : undefined,
        }}
      />
      <Box
        component="span"
        style={{
          fontFamily: '"DM Mono", monospace',
          fontSize: '0.6rem',
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: T.ore,
          opacity: 0,
          animation: inView ? `assay-word-rise 0.55s ease ${delay + 0.2}s both` : undefined,
        }}
      >
        {label}
      </Box>
    </Flex>
  );
}
